import './styles.scss';

import React from 'react';

import {UNKNOWN_ERROR} from '../../utils/ErrorUtil';
import {AppLink} from '../ui';

interface TryAgainCardProps {
    onRetry: () => void;
}

export const TryAgainCard = ({onRetry}: TryAgainCardProps) => {
    return (
        <div className='try-again-card'>
            <p>{UNKNOWN_ERROR}</p>
            <AppLink action='try-again-link' onClick={onRetry}>Try again</AppLink>
        </div>
    );
};
